(() => {
  if (window.stDupontMobileStickyActions) {
    window.stDupontMobileStickyActions.init();
    return;
  }

  const stickyActionsSelector = '.product-purchase-actions--sticky-mobile';
  const hiddenClass = 'is-hidden-at-heritage';
  let heritageObserver;

  const setStickyActionsVisibility = (heritage) => {
    const heritageReached = heritage.getBoundingClientRect().top <= window.innerHeight;

    document.querySelectorAll(stickyActionsSelector).forEach((stickyActions) => {
      stickyActions.classList.toggle(hiddenClass, heritageReached);
    });
  };

  const init = () => {
    if (heritageObserver) heritageObserver.disconnect();

    const heritage = document.querySelector('.product-heritage');
    const stickyActions = document.querySelectorAll(stickyActionsSelector);

    if (stickyActions.length === 0) return;

    if (!heritage) {
      stickyActions.forEach((actions) => actions.classList.remove(hiddenClass));
      return;
    }

    setStickyActionsVisibility(heritage);

    heritageObserver = new IntersectionObserver((entries) => {
      const entry = entries[0];
      const viewportBottom = entry.rootBounds ? entry.rootBounds.bottom : window.innerHeight;
      const heritageReached = entry.boundingClientRect.top <= viewportBottom;

      stickyActions.forEach((actions) => {
        actions.classList.toggle(hiddenClass, heritageReached);
      });
    });

    heritageObserver.observe(heritage);
  };

  window.stDupontMobileStickyActions = { init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:reorder', init);
})();
